"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = require("../../../tokens");
var _Heading = _interopRequireDefault(require("../../Text/Heading"));
var _Wrapper = _interopRequireDefault(require("../../Wrapper"));
var _Icon = require("../../Icon");
var _constants = require("../../Icon/constants");
var _Grid = _interopRequireDefault(require("../../Grid"));
var _types = require("../types");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledFlexWrapper = (0, _styledComponents.default)(_Wrapper.default).withConfig({
  displayName: "StyledFlexWrapper",
  componentId: "sc-1yvpekp-0"
})(["display:flex;gap:", ";", ""], _tokens.GTR.M, _ref => {
  let {
    $alignItems
  } = _ref;
  return $alignItems && `
    align-items: ${$alignItems};
  `;
});
const StyledContentWrapper = (0, _styledComponents.default)(_Wrapper.default).withConfig({
  displayName: "StyledContentWrapper",
  componentId: "sc-1yvpekp-1"
})(["padding-left:calc(", " + ", "px);"], _tokens.GTR.M, _constants.SIZES.S.backgroundSize);
const NON_ADJUSTABLE_ICON_PROPS = {
  size: 'S'
};
const DEFAULT_ICON_PROPS = {
  background: _tokens.COLOR.STATE.SUCCESS,
  color: _tokens.COLOR.WHITE
};
const setDefaultPropsIfUnset = iconProps => {
  return Object.entries(DEFAULT_ICON_PROPS).reduce((memo, _ref2) => {
    let [propName, defaultValue] = _ref2;
    return {
      ...memo,
      ...(iconProps[propName] === undefined && {
        [propName]: defaultValue
      })
    };
  }, {});
};
const BulletedListItem = _ref3 => {
  let {
    children,
    icon = _Icon.TickIcon,
    title,
    headingSize = _types.BULLETED_LIST_HEADING_SIZE_DEFAULT,
    ...props
  } = _ref3;
  let bullet;
  if (typeof icon === 'function') {
    bullet = /*#__PURE__*/_react.default.createElement(icon, {
      ...NON_ADJUSTABLE_ICON_PROPS,
      ...DEFAULT_ICON_PROPS
    });
  } else {
    bullet = /*#__PURE__*/_react.default.cloneElement(icon, {
      ...NON_ADJUSTABLE_ICON_PROPS,
      ...setDefaultPropsIfUnset(icon.props)
    });
  }
  return /*#__PURE__*/_react.default.createElement(_Grid.default.Item, _extends({
    tag: "li"
  }, props), title && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledFlexWrapper, {
    margin: [0, 0, 'XXS'],
    $alignItems: "center"
  }, bullet, /*#__PURE__*/_react.default.createElement(_Heading.default, {
    tag: "h2",
    size: headingSize
  }, title)), /*#__PURE__*/_react.default.createElement(StyledContentWrapper, null, children)), !title && /*#__PURE__*/_react.default.createElement(StyledFlexWrapper, null, bullet, /*#__PURE__*/_react.default.createElement(_Wrapper.default, null, children)));
};
var _default = exports.default = BulletedListItem;